module.exports = __webpack_public_path__ + "static/media/RomanSerif-Oblique-01.13442124.svg";